module.exports = __webpack_public_path__ + "static/media/icon-handshake.bcf7fc78.svg";